import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface ExplanationItemProps {
  color: string
  description: JSX.Element
  title: string
}

export const ExplanationItem: React.FC<ExplanationItemProps> = ({ color, description, title }) => (
  <div>
    <S.WrapperTitle>
      <S.CircleColor color={color} />
      <Typography variant='content1'>{title}</Typography>
    </S.WrapperTitle>

    {description}
  </div>
)